import { Divider } from 'antd';
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';
import Image from 'next/image';
import { useEffect, useState } from 'react';

import { formateErrorObject } from '../../shared/formateErrorObject';
import { notify } from '../../shared/notify';
import { Book_3D } from '../../../../assets';
import TickOnboarding from '../../../../assets/Icons/TickOnboarding';
import { getRewardRulesByName } from '../../../services/reward';

const CompleteOnboarding = () => {
  const [coins, setCoins] = useState(50);
  const screens = useBreakpoint();
  const handleRewardCoin = async () => {
    try {
      const data = await getRewardRulesByName('onboarding_complete');
      setCoins(data.data);
    } catch (error: any) {
      const message =
        formateErrorObject(error) || 'An error occurred while fetching data.';

      notify(message, 'error');
    }
  };
  useEffect(() => {
    handleRewardCoin();
  }, []);
  return (
    <div className='flex justify-center'>
      <div className='flex flex-col gap-y-1.5 md:gap-y-2'>
        <div className='flex justify-center md:pb-8'>
          <TickOnboarding width={screens.md ? '100' : '64'} />
        </div>
        <span className='text-xl md:text-2xl xl:text-3xl  text-start flex justify-center md:text-center font-semibold text-white'>
          Congratulations{' '}
          <p className='text-xl md:text-3xl xl:text-4xl inline-flex pl-2 -translate-y-0.5 md:-translate-y-2'>
            🎉
          </p>
        </span>

        <div className='text-textLightGray text-xs flex  justify-center md:text-lg  lg:text-center w-full '>
          On boarding has done successfully.
        </div>
        <div className='md:py-4'>
          <Divider className='' />
        </div>

        <div className='tracking-widest text-xs text-[#9F9EA6] flex justify-center w-full text-center mb-2'>
          REWARDS GRANTED
        </div>
        <div
          style={{
            background: 'linear-gradient(180deg, #1C1C1C 0%, #000000 100%)',
            border: '1px solid #FFFFFF1A',
          }}
          className='px-2 xxxs:px-4 rounded-xl flex gap-x-1 xxxs:gap-x-3 max-w-[400px] mb-8'
        >
          <Image
            src={Book_3D}
            alt='Book_3D'
            width={100}
            height={100}
            style={{
              maxHeight: '100%',
              objectFit: 'contain',
            }}
          />

          <div className='flex flex-col justify-between py-8 gap-y-2'>
            <div className='text-white font-semibold'>On-Boarding Reward</div>
            <span className='text-[#9F9EA6] text-xs'>
              You have been rewarded with{' '}
              <p className='text-white font-medium inline-flex'>
                {coins} Z-coins
              </p>
              . Explore store to claim free books.
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompleteOnboarding;
